import { CheckCircle } from "lucide-react";
import React from "react";
import { getBrandThemeFromDomain, getProductName, getSupportEmail } from "src/utils/brandTheme";

function RegistrationCompletePage() {
  const brandTheme = getBrandThemeFromDomain();
  const supportEmail = getSupportEmail(brandTheme);
  const productName = getProductName(brandTheme);

  const handleContactSupport = () => {
    window.location.href = `mailto:${supportEmail}?subject=AWS Marketplace Registration Complete`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-midnight to-dark-teal text-white flex items-center justify-center p-4">
      <div className="max-w-2xl mx-auto text-center">
        <div className="mb-8">
          <div className="mx-auto mb-6">
            <CheckCircle className="h-16 w-16 text-[#56A64B] mx-auto" />
          </div>
          <h1 className="text-4xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-cyan to-[#56A64B]">
            Registration Complete!
          </h1>
          <p className="text-xl text-slate-300 mb-8">
            Please check your email to complete your registration.
          </p>
        </div>

        <div className="bg-steel/30 backdrop-blur-sm rounded-xl p-8 shadow-xl border border-steel/50 space-y-6">
          <div className="bg-dark-steel/50 p-6 rounded-lg border border-steel-border/50">
            <h3 className="font-semibold text-cyan mb-3">What's Next?</h3>
            <ul className="text-sm text-slate-300 space-y-2 text-left">
              <li>
                • Your Account Representative will be in touch within 24
                business hours to guide you through onboarding.
              </li>
              <li>
                • In the meantime, you can log into {productName} to get started with connecting your integrations.
              </li>
            </ul>
          </div>

          <div className="text-center text-sm text-slate-400">
            Need immediate assistance?{" "}
            <button
              onClick={handleContactSupport}
              className="text-cyan hover:text-[#56A64B] transition-colors"
            >
              Contact our support team
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegistrationCompletePage;